import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "relation-net"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "邀请我的人", -1);

const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "我邀请的人", -1);

const _hoisted_6 = /*#__PURE__*/_createTextVNode("关闭");

import { ref, watch } from 'vue';
import { getSalesmanInvitationRelation } from '@/request';
export default {
  name: 'relationNetModal',
  props: {
    modelValue: Boolean,
    supUserId: String
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit: emits
  }) {
    const porps = __props;
    const upperTable = ref([]);
    const lowerTable = ref([]);
    const columns = [{
      label: '姓名',
      prop: 'linkMan'
    }, {
      label: '手机号',
      prop: 'linkPhone'
    }, {
      label: '团队角色',
      prop: 'employeeTypeName'
    }, {
      label: '业务员类型',
      prop: 'salesmanTypeName'
    }, {
      label: '业务区域',
      prop: 'salesmanAreaName'
    }, {
      label: '加入时间',
      prop: 'createAt',
      width: 130
    }];
    watch(() => porps.supUserId, () => {
      getDetail();
    });
    const loading = ref(false);

    function getDetail() {
      loading.value = true;
      getSalesmanInvitationRelation({
        supUserId: porps.supUserId
      }).then(res => {
        let {
          lowerLeverInfo,
          upperLeverInfo
        } = res.data;
        upperTable.value = upperLeverInfo;
        lowerTable.value = lowerLeverInfo;
      }).finally(() => {
        loading.value = false;
      });
    }

    function close() {
      emits('update:modelValue', false);
    }

    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: __props.modelValue,
        title: "查看邀请关系",
        width: "700px",
        top: "50px",
        onClose: close
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: close
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_table, {
          data: upperTable.value,
          size: "small",
          maxHeight: "300px"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, item => {
            return _createVNode(_component_el_table_column, {
              label: item.label,
              prop: item.prop,
              width: item.width,
              key: item.prop
            }, null, 8, ["label", "prop", "width"]);
          }), 64))]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_table, {
          data: lowerTable.value,
          size: "small",
          maxHeight: "300px"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, item => {
            return _createVNode(_component_el_table_column, {
              label: item.label,
              prop: item.prop,
              width: item.width,
              key: item.prop
            }, null, 8, ["label", "prop", "width"]);
          }), 64))]),
          _: 1
        }, 8, ["data"])])])), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};